import React, {useState, useEffect} from 'react'
import { Modal } from '../../modal/Modal';
import { InputProfile } from '../../input/InputProfile';
import {formatErrors, roleCurator} from '../../../constants';
import {useDispatch, useSelector} from "react-redux";
import { ActionNodeMessage } from './ActionNodeMessage';
import {StartNodeStart} from "./StartNodeStart";
import {ConditionNodeCondition} from "./ConditionNodeCondition";
import { ActionNodeTimer } from './ActionNodeTimer';
import { triggerFileAction } from '../../../actions/triggersAction';
import { toast } from 'react-toastify';
import { ActionNodeWaiting } from './ActionNodeWaiting';

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function NodeModal({trigger, itemID, type, data, handleOk, triggerWrap = true}) {
  const [open, setOpen] = useState(false)
  const handleClose = (value) => {
    setOpen(!open);
  }
  return (
    <Modal open={open} onClose={handleClose} trigger={trigger} triggerWrap={triggerWrap} isFlow={true} isWide={true}>
      <NodeModalContent itemID={itemID} type={type} data={data} handleOk={handleOk} setOpen={setOpen} />
    </Modal>
  )
}

function NodeModalContent({itemID, type, data, handleOk, setOpen}) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [nodeTypes] = useState([
    { key: "StartNode", text: "Старт", value: "StartNode" },
    { key: "ConditionNode", text: "Блок с условием", value: "ConditionNode" },
    { key: "ActionNode", text: "Блок с действием", value: "ActionNode" },
  ]);

  const [actionTypes] = useState([
    { key: "MS", text: "Сообщение", value: "MS" },
    { key: "TM", text: "Таймер", value: "TM" },
    { key: "WT", text: "Ожидание ввода", value: "WT" },
  ]);

  const dispatch = useDispatch();
  const user = useSelector(state => state.user.profile);
  const curatorId = user && user.id && user.role_id === roleCurator ? user.id : null;

  const [form, handleChange] = useState({
    id: uuidv4(),
    type: '',
    data: data || {
      // start node
      value: '',
      date: '',
      run_time: '',
      periodicity: 'W',
      monday: true,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      trigger_type: '',
      event_type: '',
      delay: 180,
      period_delay: 1,
      start_date: '',
      end_date: '',
      timezone_cfg: 'Europe/Moscow',
      // condition node
      operator: 'AND',
      conditions: [
        {
          cond: 'COURSE',
          cond_type: 'EQ',
          value: '',
        }
      ],
      // action node
      action_type: 'MS',
      action_date: '',
      message_type: 'TXT',
      message: '',
      curator_id: curatorId || '',
      program_stages: {},
      program_stages_weeks: {},
      file: null,
      in_archive: false,
      course: 1,
      in_week: false,
      last_message: 0,
      // timer node
      timer_type: 'M',
      timer_value: 1,
      recipient: 1,
      wait_type: 'phone',
      send_hour_limit: 0
    },
    position: {x: 100, y: 100}
  });

  const handleChangeData = (data) => {
    handleChange({...form, data: data});
  }

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({
      ...form, 
      data: {
        ...form.data,
        [name]: value
      }
    });
    setErrors({...errors, [name]: value.trim() === ''});
  }

  const handleChangeDropDown = (e, data) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({...form, [name]: value});
    setErrors({...errors, [name]: !value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }

    let errs = {};
    if (form.type.trim() === '') {
      errs.type = true;
    }
    if (form.data.value.trim() === '') {
      errs.value = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);
    let item = {
      ...form,
      data: {
        ...form.data,
        delay: !isNaN(parseInt(form.data.delay)) ? parseInt(form.data.delay) : 0,
        period_delay: !isNaN(parseInt(form.data.period_delay)) ? parseInt(form.data.period_delay) : 0,
        timer_value: !isNaN(parseInt(form.data.timer_value)) ? parseInt(form.data.timer_value) : 0,
        recipient: !isNaN(parseInt(form.data.recipient)) ? parseInt(form.data.recipient) : 0,
        monday: form.data.periodicity === "W" && 
                !form.data.monday && 
                !form.data.tuesday && 
                !form.data.wednesday && 
                !form.data.wednesday && 
                !form.data.friday && 
                !form.data.saturday && 
                !form.data.saturday ? true : form.data.monday,
        send_hour_limit: !isNaN(parseInt(form.data.send_hour_limit)) ? parseInt(form.data.send_hour_limit) : 0,
      }
    };
    if (item.data.file !== null && typeof item.data.file.id === "undefined") {
      dispatch(triggerFileAction(item.id, item.data.file)).then((res) => {
        handleOk({...item, data: {
          ...item.data,
          file: res,
        }});
        setOpen(false);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    } else {
      handleOk(item);
      setOpen(false);
    }
  }

  useEffect(() => {
    if (itemID) {
      handleChange({
        id: itemID,
        type: type,
        data: data
      });
    }
  }, [itemID, type, data]);

  return <React.Fragment>
    <div className="modal__title">{itemID ? "Редактировать блок" : "Добавить блок"}</div>

    <div className="modal__scroll profile__inner--wide">
      <form noValidate>
        
        <div className="profile__wrap">
          <div className="profile__group">
            <label className="profile__label help">Тип блока</label>
            <select 
              className={`dropdown__select select ${errors.type ? 'is-invalid' : ''}`}
              name="type"
              value={form.type}
              disabled={!!itemID}
              onChange={handleChangeDropDown}
            >
              <option value="">пожалуйста выберите блок</option>
              {nodeTypes.map(option => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>

          <InputProfile type="text"
                        title="Заголовок"
                        name="value"
                        placeholder="Введите значение"
                        value={form.data.value}
                        error={errors.value || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>
        </div>

        {!!itemID && <>
          {form.type === 'StartNode' && <StartNodeStart form={form.data} errors={errors} loading={loading}
                                                        setForm={handleChangeData} setErrors={setErrors} />}

          {/** ---------------------------------------------- */}
          {form.type === 'ConditionNode' && <ConditionNodeCondition form={form.data} errors={errors} loading={loading}
                                                        setForm={handleChangeData} setErrors={setErrors} />}

          {/** ---------------------------------------------- */}
          {form.type === 'ActionNode' && <>
            <div className="profile__wrap"> 
              <div className="profile__group">
                <label className="profile__label help">Тип действия</label>
                <select 
                  className={`dropdown__select select ${errors.action_type ? 'is-invalid' : ''}`}
                  name="action_type"
                  value={form.data.action_type}
                  onChange={handleChangeForm}
                >
                  {actionTypes.map(option => (
                    <option key={option.value} value={option.value}>{option.text}</option>
                  ))}
                </select>
              </div>
            </div>

            {form.data.action_type === 'MS' && <div className="profile__wrap"> 
              <ActionNodeMessage form={form.data} errors={errors} loading={loading} setForm={handleChangeData} user={user} />
            </div>}

            {form.data.action_type === 'TM' && <div className="profile__wrap"> 
              <ActionNodeTimer form={form.data} errors={errors} loading={loading} setForm={handleChangeData} user={user} />
            </div>}

            {form.data.action_type === 'WT' && <div className="profile__wrap"> 
              <ActionNodeWaiting form={form.data} errors={errors} loading={loading} setForm={handleChangeData} user={user} />
            </div>}
          </>}
        </>}            
      </form>
    </div>

    <div className="modal__btns" style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
      {!!itemID && 
        <button type="button" className="modal__btn btn grey" onClick={() => setOpen(false)}>Отмена</button>
      }
      {!data?.disabled && <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>
        {loading ? 'Загрузка...' : itemID ? "Сохранить" : "Добавить"}
      </button>}
    </div>
  </React.Fragment>
}

export default NodeModal
